<template>
  <v-dialog
    v-model="open"
    max-width="700px"
    scollable
    content-class="dialog-top-right"
  >
    <template #activator="{ props }">
      <slot :props="props"></slot>
    </template>

    <v-card flat>
      <v-toolbar dense flat dark color="primary">
        <v-toolbar-title><v-icon> mdi-help-circle-outline</v-icon>&nbsp;&nbsp;<b>Invite members</b></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn variant="text" icon color="grey" @click="open = false">
          <v-icon >mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="mt-1">
        <h3>Add people by email</h3>
        You can invite people to your project by entering their email addresses.
        Type or paste an email address into the field, press Enter,
        and then click the Invite button.
        The invited people will receive an email with a link to the project.
        <br><br>
        <b>Note:</b>
        Access is granted to the entire project.
        Invited people will be able to see all workflows within the project.
        <br><br>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      open: false
    }
  }
}
</script>
